<template>
	<div class="p-categories" v-if="rootCategory.children">
		<NuxtLink v-for="subcategory in subcategories" :key="subcategory.id" :to="subcategory.url_without_domain" class="p-category">
			<span>{{ subcategory.title }}</span>
			<ClientOnly>
				<span class="p-category-img" v-if="subcategory.main_image_upload_path">
					<BaseUiImage :src="subcategory.main_image_upload_path" :alt="subcategory.title" width="30" height="30" loading="lazy" />
				</span>
			</ClientOnly>
		</NuxtLink>
		<NuxtLink class="p-btn-all" :to="rootCategory?.url_without_domain" v-if="category && category.level > 1">
			<span>{{ labels.get('publish_categories_show_all') }}</span>
		</NuxtLink>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['category', 'rootCategory']);

	const subcategories = computed(() => {
		return props.rootCategory.children.filter(el => {
			return el.url != props.category.url;
		});
	});
</script>

<style scoped lang="less">
	.p-categories {
		display: flex;
		justify-content: space-between;
		font-size: 16px;
		line-height: 1.5;
		letter-spacing: -0.3px;
		margin-top: 10px;
		@media (max-width: @m) {
			font-size: 12px;
		}
		@media (max-width: @ms) {
			flex-wrap: wrap;
			font-size: 14px;
			margin-top: 5px;
		}
	}
	.p-category {
		display: flex;
		align-items: center;
		color: @textColor;
		position: relative;
		padding: 0 0 20px 30px;
		text-decoration: none;
		@media (max-width: @t) {
			padding: 0 0 12px 0;
		}
		@media (max-width: @ms) {
			width: calc(~'100% / 2');
			padding: 0 10px 0 25px;
			margin-bottom: 13px;
		}
		&:after {
			.pseudo(auto;3px);
			left: 0;
			right: 0;
			bottom: -1px;
			background: @blue;
			opacity: 0;
			.transition(opacity);
			@media (max-width: @t) {
				content: none;
			}
		}
		.p-category-img {
			position: absolute;
			left: 0;
			@media (max-width: @t) {
				display: none;
			}
			@media (max-width: @ms) {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 17px;
			}
			:deep(img) {
				width: auto;
				height: auto;
				max-width: 23px;
				max-height: 21px;
				display: block;
				@media (max-width: @ms) {
					max-width: 17px;
					max-height: 17px;
				}
			}
		}
		&:hover {
			text-decoration: none;
			color: @blue;
			&:after {
				opacity: 1;
			}
			@media (max-width: @t) {
				text-decoration: none;
				color: @textColor;
			}
		}
		&.no-image {
			padding-left: 0;
			@media (max-width: @ms) {
				padding-left: 23px;
			}
		}
	}
	.p-btn-all {
		font-size: 16px;
		line-height: 1.5;
		letter-spacing: -0.3px;
		font-weight: 600;
		color: @blue;
		text-decoration: none;
		position: relative;
		@media (max-width: @m) {
			font-size: 12px;
		}
		@media (max-width: @ms) {
			width: calc(~'100% / 2');
			font-size: 14px;
			padding: 0 10px 13px 25px;
		}
		&:after {
			.pseudo(auto;3px);
			left: 0;
			right: 0;
			bottom: 0;
			background: @blue;
			opacity: 0;
			.transition(opacity);
			@media (max-width: @t) {
				content: none;
			}
		}
		&:hover {
			text-decoration: none;
			color: @blue;
			&:after {
				opacity: 1;
			}
			@media (max-width: @t) {
				color: @blue;
			}
		}
	}
</style>
